module.exports = __webpack_public_path__ + "static/media/consultoria2.3be4d7c2.jpg";